// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------
import MansionImage from '@components/common/MansionList/MansionImage';
import { AppConfigContext } from '@providers/AppConfigProvider';

// Section for import custom types -------------------------------------------------------------------------------------
import { MansionListItemPropsData } from '@/types/components/common/MansionList/MansionListPropsData';

interface Props {
  data: MansionListItemPropsData;
}

export default function MansionItem({ data }: Props): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);
  return (
    <Box className="relative w-[280px] max-md:w-[265px] h-[342px] max-md:h-[332px] rounded-lg shadow-[1px_1.5px_6px_0px_rgba(0,0,0,0.22)] mb-4 max-md:mb-3">
      {data.is_sale && (
        <Box className="absolute top-0 right-0 z-10">
          <Box component="img" src={`${pathRoot}/assets/images/common/sell_r_8.svg`} alt="sellLabel" />
        </Box>
      )}
      <Box className="relative">
        <MansionImage
          src={data.thumbnail_image_url.sm}
          alt={data.mansion_name}
          href={`/karte/mansions/detail/${data.id}/`}
        />
      </Box>
      <Box className="mx-4">
        <Link underline="none" href={`/karte/mansions/detail/${data.id}/`} variant="body1">
          <Box className="mb-2 text-base text-rf-blue font-bold line-clamp-2" sx={{ display: 'block' }}>
            {data.mansion_name}
          </Box>
          <Typography className="text-rf-black line-clamp-1" variant="body2">
            {data.address_display}
          </Typography>
          <Typography className="mt-1 text-rf-black line-clamp-2" variant="body2">
            {data.transit_display}
          </Typography>
          <Typography className="mt-1 text-rf-black" variant="body2">
            築年月：{data.build_created_date_display}
          </Typography>
        </Link>
      </Box>
    </Box>
  );
}
